import { create } from 'zustand'

interface UiState {
  loginModalOpen: boolean
  loginActionDisabled: boolean
  openLoginModal: () => void
  closeLoginModal: () => void
  setLoginActionDisabled: (disabled: boolean) => void
}

export const useUiStore = create<UiState>()((set) => ({
  loginModalOpen: false,
  loginActionDisabled: false,
  openLoginModal: () => set({ loginModalOpen: true }),
  closeLoginModal: () => set({ loginModalOpen: false }),
  setLoginActionDisabled: (disabled) => set({ loginActionDisabled: disabled }),
}))
